define('casino/info',[], function () {
    'use strict';
    var SMALL_SCREEN_WIDTH = 1366;
    var SMALL_SCREEN_HEIGHT = 900;


    var BOTTOM_LEVEL_SCREEN_WIDTH = 1365;
    var MEDIUM_LEVEL_SCREEN_WIDTH = 1530;

    function isSmallScreen() {
        if (screen.width <= SMALL_SCREEN_WIDTH || screen.height <= SMALL_SCREEN_HEIGHT) {
            return true;
        }

        if (window.innerWidth <= SMALL_SCREEN_WIDTH) {
            return true;
        }

        return false;
    }

    function isScreenWidthEqualOrLessThanBottomLevel() {
        var actualWindowWidth = window.innerWidth;

        if (actualWindowWidth <= BOTTOM_LEVEL_SCREEN_WIDTH) {
            return true;
        }
        return false;
    }

    function isScreenWidthBetweenBottomLevelAndMediumLevel() {
        var actualWindowWidth = window.innerWidth;

        if (BOTTOM_LEVEL_SCREEN_WIDTH < actualWindowWidth && actualWindowWidth < MEDIUM_LEVEL_SCREEN_WIDTH) {
            return true;
        }
        return false;
    }

    function isScreenWidthGreaterOrEqualThanMediumLevel() {
        var actualWindowWidth = window.innerWidth;

        if (actualWindowWidth >= MEDIUM_LEVEL_SCREEN_WIDTH) {
            return true;
        }
        return false;
    }

    var casinoInfo = {
        isSmallScreen: isSmallScreen,
        isScreenWidthEqualOrLessThanBottomLevel: isScreenWidthEqualOrLessThanBottomLevel,
        isScreenWidthBetweenBottomLevelAndMediumLevel: isScreenWidthBetweenBottomLevelAndMediumLevel,
        isScreenWidthGreaterOrEqualThanMediumLevel: isScreenWidthGreaterOrEqualThanMediumLevel

    };

    return casinoInfo;
});

